import actionTypes from '../constants/action-types';

const setCurrentButtonPresetVersion = (version) => ({
  type: actionTypes.SET_CURRENT_BUTTON_PRESET_VERSION,
  payload: {
    version,
  },
});

export default setCurrentButtonPresetVersion;
